import styled, { css } from "styled-components";
import { useSwiper } from "swiper/react";

const ArrowButton = styled.button`
  border: none;
  cursor: pointer;
  padding: 0;
  height: 24px;
  width: 24px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-07']};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors['neutral-07']};
  
  path {
    color: ${({ theme }) => theme.colors['neutral-01']};
  }

  &.arrow-left svg {
    margin-right: 10px;
    transform: translateX(50%);
  }

  &.arrow-right svg {
    margin-left: 9px;
    transform: translateX(-50%);
  }

  ${({ disabled, theme }) => disabled && css`
    border-color: ${theme.colors['neutral-04']};
    background-color: ${theme.colors['neutral-01']};

    &:hover {
      cursor: not-allowed;
    }

    path {
      color: ${theme.colors['neutral-04']};
    }
  `}

  :is([data-theme="dark"] &) {
    background-color: ${({ theme }) => theme.colors['neutral-01']};
    border-color: ${({ theme }) => theme.colors['neutral-01']};

    path {
      color: ${({ theme }) => theme.colors['neutral-04']};
    }

    ${({ disabled, theme }) => disabled && css`
      border-color: ${theme.colors['neutral-03']};
      background-color: ${theme.colors['background-02']};

      path {
        color: ${theme.colors['neutral-04']};
      }
    `}
  }
`;

const ArrowContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export function SlideArrowNavigation() {
  const swiper = useSwiper();

  return (
    <ArrowContainer className="arrow-container">
      <ArrowButton
        className="arrow-left"
        disabled={swiper.isBeginning}
        onClick={() => swiper.slidePrev()}
      >
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 10.6668L1.33333 6.00016L6 1.3335" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </ArrowButton>

      <ArrowButton
        className="arrow-right"
        disabled={swiper.isEnd}
        onClick={() => swiper.slideNext()}
      >
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1.33317L5.66667 5.99984L1 10.6665" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </ArrowButton>
    </ArrowContainer>
  );
}